import { Injectable } from "@angular/core";
import { Subject, from } from "rxjs";

@Injectable({ providedIn: "root" })
export class EventService {
  listeners: any = {};

  eventsSubject: any = new Subject();

  events: any;

  constructor() {
    this.events = from(this.eventsSubject);
    this.events.subscribe(({ name, args }: any) => {
      if (this.listeners[name]) {
        Object.values(this.listeners[name]).forEach((listener: any) =>
          listener(...args),
        );
      }
    });
  }

  private addEvent(name: string, id: string, listener: () => any) {
    if (this.listeners[name]) {
      this.listeners[name][id] = listener;
    } else {
      this.listeners[name] = { [id]: listener };
    }
  }

  public on(name: string | string[], id: string, listener: () => any): any {
    if (Array.isArray(name)) {
      return name.forEach((item: any) => this.addEvent(item, id, listener));
    }
    return this.addEvent(name, id, listener);
  }

  public off(name: string, id?: string) {
    if (id) {
      this.listeners[name] = Object.entries(this.listeners[name]).reduce(
        (acc, [key, value]: any) => {
          if (key !== id) {
            return { ...acc, [key]: value };
          }
          return acc;
        },
        {},
      );
    } else {
      this.listeners[name] = {};
    }
  }

  public emit(name: string, ...args: any) {
    this.eventsSubject.next({ name, args });
  }
}
